/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {StickyHeaderSimpleButtonComponent} from './sticky-header-simple-button.component';
import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-sticky-header-icon-button',
    templateUrl: './sticky-header-icon-button.component.html',
    styleUrls: [
        './sticky-header-simple-button.component.css',
        './sticky-header-icon-button.component.css'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StickyHeaderIconButtonComponent extends StickyHeaderSimpleButtonComponent {
    icon: string;
}
